import { baseRequest } from '@/utils/request'

const request = (url, ...arg) =>  baseRequest(`/biz/c/coalescequestionrecord/${url}`, ...arg)
/**
 * 指标汇报记录
 *
 */
export default {
	// 详情
	detail(data) {
		return request('detail', data, 'get')
	},
	// 获取上一次提交记录
	getLastSubmit(data) {
		return request('getLastSubmit', data, 'get')
	},
	// 调查指标保存
	add(data) {
		return request('add', data)
	},
	// 调查指标提交
	submit(data) {
		return request('submit', data)
	},
	// 获取企业指标汇报待提交数量
	unSubmitRecordCount(data) {
		return request('unSubmitRecordCount', data, 'get')
	},
}
